export enum ExtractedEntityCategoryTypeKey {
  PRIMARY_EXECUTORS = 'primary_executors',
  ALTERNATE_EXECUTORS = 'alternate_executors',
  PRIMARY_RESIDUAL_BENEFICIARIES = 'primary_residual_beneficiaries',
  ALTERNATE_RESIDUAL_BENEFICIARIES = 'alternate_residual_beneficiaries',
  PRIMARY_SPECIFIC_BENEFICIARIES = 'primary_specific_beneficiaries',
  ALTERNATE_SPECIFIC_BENEFICIARIES = 'alternate_specific_beneficiaries',
  DEFAULT = 'default'
}
